import processAppointmentTypeJSON from "../AppointmentScheduler/processAppointmentType";
import processAppointmentClinic from "../AppointmentScheduler/processAppointmentClinic";
import processAppointmentStatus from "../AppointmentScheduler/processAppointmentStatus";
import capitalize from "capitalize";
import { DateTime } from "luxon";
const handleUserConfigurations = (
    user_configurations,
    appointment_assignable_employees,
    clinics,
) => {
    const APPOINTMENTTYPE = processAppointmentTypeJSON();
    const CLINICS = processAppointmentClinic();
    const APPOINTMENTSTATUS = processAppointmentStatus();
    const getBooleanValue = (array = [], itemID) =>
        array.find((i) => i.id === itemID)?.filtered ?? true;
    const handleAppointmentResourceEmployees = () => {
        let appointment_resource_employees_source_and_check_if_have_new_employees =
            appointment_assignable_employees.map((employee) => {
                if (employee.clinics?.length === 1) {
                    const user_clinic = clinics?.find(
                        (clinic) => clinic.uuid === employee.clinics[0],
                    );
                    if (user_clinic) {
                        return {
                            id: employee.uuid,
                            text: `${
                                employee?.title ? employee.title + " " : ""
                            }${capitalize.words(
                                employee?.first_name || "",
                            )} ${capitalize.words(employee?.last_name || "")}`,
                            filtered: getBooleanValue(
                                user_configurations?.appointment_resource_employees,
                                employee.uuid,
                            ),
                            clinic: user_clinic.name.toLowerCase(),
                            ms_group_id:
                                employee?.ms_group_id ||
                                "00000000-0000-0000-0000-000000000000",
                        };
                    }
                }
                return {
                    id: employee.uuid,
                    text: `${
                        employee?.title ? employee.title + " " : ""
                    }${capitalize.words(
                        employee?.first_name || "",
                    )} ${capitalize.words(employee?.last_name || "")}`,
                    filtered: getBooleanValue(
                        user_configurations?.appointment_resource_employees,
                        employee.uuid,
                    ),
                    clinic: "all",
                    ms_group_id:
                        employee?.ms_group_id ||
                        "00000000-0000-0000-0000-000000000000",
                };
            });
        appointment_resource_employees_source_and_check_if_have_new_employees =
            [
                ...appointment_resource_employees_source_and_check_if_have_new_employees,
                {
                    id: "00000000-0000-0000-0000-000000000000",
                    text: "Void Employee",
                    filtered:
                        user_configurations?.appointment_resource_employees.find(
                            (item) =>
                                item.id ===
                                "00000000-0000-0000-0000-000000000000",
                        )?.filtered ?? true,
                    clinic: "all",
                    ms_group_id: "00000000-0000-0000-0000-000000000000",
                },
            ];
        localStorage.appointment_resource_employees = JSON.stringify(
            appointment_resource_employees_source_and_check_if_have_new_employees,
        );
    };
    const handleAppointmentResourceTypes = () => {
        const appointment_types_source_and_check_if_have_new_types =
            APPOINTMENTTYPE.map((item) => ({
                ...item,
                filtered: getBooleanValue(
                    user_configurations?.appointment_types,
                    item.id,
                ),
            }));
        localStorage.appointment_types = JSON.stringify(
            appointment_types_source_and_check_if_have_new_types,
        );
    };
    const handleAppointmentResourceClinics = () => {
        const appointment_clinics_source_and_check_if_have_new_clinics =
            CLINICS.map((item) => ({
                ...item,
                filtered: getBooleanValue(
                    user_configurations?.appointment_clinics,
                    item.id,
                ),
            }));
        localStorage.appointment_clinics = JSON.stringify(
            appointment_clinics_source_and_check_if_have_new_clinics,
        );
    };
    const handleAppointmentStatus = () => {
        const appointment_status_source_and_check_if_have_new_status =
            APPOINTMENTSTATUS.map((item) => ({
                ...item,
                filtered: getBooleanValue(
                    user_configurations?.appointment_status,
                    item.id,
                ),
            }));
        localStorage.appointment_status = JSON.stringify(
            appointment_status_source_and_check_if_have_new_status,
        );
    };
    localStorage.appointmentCurrentDate = JSON.stringify(
        DateTime.now().toFormat("yyyy'-'MM'-'dd"),
    );
    localStorage.appointmentCurrentViewName = JSON.stringify(
        user_configurations?.appointment_current_view_name || "Day",
    );
    localStorage.appointmentMainResourceName = JSON.stringify(
        user_configurations?.appointment_main_resource_name ||
            "employees_uuids",
    );
    localStorage.appointmentColorSchema = JSON.stringify(
        user_configurations?.appointment_color_schema || "appointment_type",
    );
    localStorage.appointmentStartDayHour = JSON.stringify(
        user_configurations?.appointment_start_day_hour || 8,
    );
    localStorage.appointmentEndDayHour = JSON.stringify(
        user_configurations?.appointment_end_day_hour || 19,
    );
    localStorage.appointmentCellDuration = JSON.stringify(
        user_configurations?.appointment_cell_duration || 15,
    );
    handleAppointmentResourceEmployees();
    handleAppointmentResourceTypes();
    handleAppointmentResourceClinics();
    handleAppointmentStatus();
    localStorage.work_site = user_configurations?.work_site || "";
    localStorage.displayModalAppendixOpen = JSON.stringify(
        user_configurations?.displayModalAppendixOpen ?? true,
    );
};
export default handleUserConfigurations;
